
import React, { useContext, useEffect, useState } from 'react'


const MscerHeader = () => {
    
    

    return (
        <>
            <header className='fixed top-0  ' style={{left:"50%",transform: 'translateX(-50%)'}}>
                <div className="flex items-center justify-center">
                        {/* <h1 className='text-3xl'>WovvMap</h1> */}
                        <img src='images/logoHeader.png' width={200} />
                        <h1 className='font-normal'>Powered By </h1>
                        <a href='https://wovvtech.com/' target={'_blank'}><img src='images/wovvtech_logo.jpg' width={70} className="ml-1"/></a>
                    
                </div>

                {/* <div className="flex items-center justify-center mt-5">
                    
                </div> */}

                
            </header>
        </>
    );
};

export default MscerHeader